(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alankrit-build-box"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alankrit-box')) {
  customElements.define('alankrit-box', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.picks = [];
      this.busy = false;
      this.msg = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.addEventListener('click', event => this.handleClick(event));
      this.renderBox();
      this.trayObserver = new ResizeObserver(() => {
        this.style.setProperty('--tray-height', `${this.querySelector('.ab-box').offsetHeight + 24}px`);
      });
      this.trayObserver.observe(this.querySelector('.ab-box'));
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.classList.toggle('ab-visible', entries[0].isIntersecting);
      });
      this.visibilityObserver.observe(this);
      this.addEventListener('change', event => { if (event.target.matches('select')) this.renderBox(); });
    }
    disconnectedCallback() {
      this.trayObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.initialized = false;
    }
    say(message) { this.querySelector('[data-status]').textContent = message; }
    renderBox() {
      const slots = this.querySelector('[data-slots]');
      slots.replaceChildren();
      for (let index = 0; index < 4; index++) {
        const slot = document.createElement('div');
        slot.className = 'ab-slot';
        const pick = this.picks[index];
        if (pick) {
          slot.classList.add('ab-filled');
          if (pick.image) {
            const image = document.createElement('img');
            image.src = pick.image; image.alt = pick.title; slot.append(image);
          }
          const title = document.createElement('p'); title.textContent = pick.title; slot.append(title);
          if (pick.name !== 'Default Title') {
            const variant = document.createElement('small'); variant.textContent = pick.name; slot.append(variant);
          }
          const remove = document.createElement('button');
          remove.type = 'button'; remove.dataset.remove = index;
          remove.textContent = this.msg.remove;
          remove.setAttribute('aria-label', `${this.msg.remove}: ${pick.title}`);
          remove.disabled = this.busy; slot.append(remove);
        } else {
          slot.textContent = `${this.msg.slot} ${index + 1}`;
        }
        slots.append(slot);
      }
      this.querySelector('[data-progress]').value = this.picks.length;
      this.querySelector('[data-count]').textContent = `${this.picks.length} / 4`;
      this.querySelectorAll('[data-add]').forEach(button => {
        const card = button.closest('[data-product]');
        const chosen = this.picks.filter(pick => pick.product === card.dataset.product).length;
        card.classList.toggle('ab-selected', chosen > 0);
        card.dataset.chosen = chosen;
        const option = card.querySelector('select').selectedOptions[0];
        button.disabled = this.busy || this.picks.length === 4 || !option || option.dataset.available !== 'true';
      });
      const button = this.querySelector('[data-submit]');
      button.disabled = this.busy || this.picks.length !== 4;
      button.textContent = this.busy ? this.msg.busy : this.picks.length === 4 ? this.msg.submit : `${this.msg.choose} (${this.picks.length}/4)`;
    }
    async handleClick(event) {
      const button = event.target.closest('button');
      const pageLink = event.target.closest('.ab-pagination a');
      if (this.busy) { if (button || pageLink) event.preventDefault(); return; }
      if (pageLink) {
        event.preventDefault(); this.busy = true; this.renderBox(); this.say('');
        try {
          const response = await fetch(pageLink.href, {credentials:'same-origin'});
          if (!response.ok) throw new Error();
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = doc.getElementById(this.id);
          const catalog = section && section.querySelector('[data-catalog]');
          if (!catalog) throw new Error();
          this.querySelector('[data-catalog]').replaceChildren(...catalog.childNodes);
          this.querySelector('[data-catalog]').scrollIntoView({behavior:'smooth',block:'start'});
        } catch { this.say(this.msg.error); }
        finally { this.busy = false; this.renderBox(); }
        return;
      }
      if (!button) return;
      if (button.hasAttribute('data-add')) {
        if (this.picks.length >= 4) { this.say(this.msg.full); return; }
        const card = button.closest('[data-product]');
        const option = card.querySelector('select').selectedOptions[0];
        if (!option || option.dataset.available !== 'true') return;
        if (this.dataset.repeat !== 'true' && this.picks.some(p => p.product === card.dataset.product)) { this.say(this.msg.repeat); return; }
        this.picks.push({id:option.value,product:card.dataset.product,handle:card.dataset.handle,title:card.dataset.title,name:option.dataset.name,image:option.dataset.image});
        this.say(''); this.renderBox();
      } else if (button.hasAttribute('data-remove')) {
        this.picks.splice(Number(button.dataset.remove),1); this.say(''); this.renderBox();
      } else if (button.hasAttribute('data-submit')) {
        await this.submitBox();
      }
    }
    async submitBox() {
      if (this.busy || this.picks.length !== 4) return;
      this.busy = true; this.renderBox(); this.say('');
      let adding = false;
      try {
        const root = this.dataset.root.replace(/\/?$/, '/');
        const handles = [...new Set(this.picks.map(p => p.handle))];
        const products = await Promise.all(handles.map(async handle => {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`,{credentials:'same-origin'});
          if (!response.ok) throw new Error(this.msg.error);
          return [handle,await response.json()];
        }));
        const catalog = new Map(products);
        this.picks.forEach(pick => {
          const product = catalog.get(pick.handle);
          const variant = product.variants.find(v => String(v.id) === pick.id);
          if (!variant || !variant.available) throw new Error(`${pick.title}: ${this.msg.changed}`);
          pick.title = product.title; pick.name = variant.title;
        });
        const quantities = new Map();
        this.picks.forEach(pick => quantities.set(pick.id, (quantities.get(pick.id) || 0) + 1));
        const items = Array.from(quantities, ([id, quantity]) => ({id:Number(id), quantity}));
        adding = true;
        const response = await fetch(`${root}cart/add.js`,{
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        if (!response.ok) {
          window.location.assign(`${root}cart`);
          return;
        }
        const code = this.dataset.discount.trim();
        window.location.assign(code ? `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(root + 'cart')}` : `${root}cart`);
      } catch (error) {
        if (adding) {
          window.location.assign(`${this.dataset.root.replace(/\/?$/, '/')}cart`);
          return;
        }
        this.say(error.message || this.msg.error); this.busy = false; this.renderBox();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-offers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.alankrit-offer__code');

    if (!button) return;

    const code = button.dataset.code;
    const label = button.querySelector('.alankrit-offer__copy');

    if (!code) return;

    navigator.clipboard.writeText(code).then(function() {
      if (label) {
        const originalText = label.textContent;
        label.textContent = 'COPIED';

        setTimeout(function() {
          label.textContent = originalText;
        }, 1500);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            jdgm.customizeBadges();
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('data-phototview');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
